export default {
  title: "SMS mobile 1.0"
};
